module.exports = __webpack_public_path__ + "img/icon-no-history.d0482da1.svg";